// Modelo unico de sesion de modo gestion. Dueno de TODA la destruccion de
// sesion (afiliado, operador, o ambas). Ningun otro archivo del repo debe
// llamar `sessionStorage.clear()` desnudo ni reinventar la lista de claves
// con `removeItem` sueltos: siempre pasar por clearAffiliateSession(),
// clearOperatorSession() o clearAllSession() de este archivo.
//
// Tres senales ortogonales, fuente unica de verdad del render:
// - esFrame(): runtime, no persistida. Discrimina iframe vs top-level.
// - hayContextoOperador(): persistida (gestion_sid). Vive hasta 4h (TTL).
// - viendoAfiliado(): persistida (gestion_viendoAfiliado + token de afiliado).

// Claves de la sesion de afiliado (token, datos, contador de errores de login).
export const AFFILIATE_KEYS = [
    'token',
    'nroafi',
    'caduca',
    'emailAuth',
    'user',
    'distrito',
    'esModoGestion',
    'erroresLogin',
]

// Claves de la sesion de operador (contexto de modo gestion).
export const OPERATOR_KEYS = [
    'gestion_sid',
    'gestion_usuiden',
    'gestion_idArea',
    'gestion_viendoAfiliado',
    'gestion_nroafiActivo',
]

// Estamos dentro de un iframe same-origin? (el portal del afiliado cargado
// dentro del wrapper de gestion).
export function esFrame() {
    return window.parent !== window
}

// Hay una sesion de operador activa en esta pestana?
export function hayContextoOperador() {
    return !!sessionStorage.getItem('gestion_sid')
}

// Estamos viendo un afiliado dentro del iframe de gestion?
export function viendoAfiliado() {
    return sessionStorage.getItem('gestion_viendoAfiliado') === '1'
        && !!sessionStorage.getItem('token')
}

// Borra SOLO la sesion del afiliado. Nunca toca OPERATOR_KEYS: es seguro
// llamarla mientras hay contexto de operador activo (ej. al volver de ver
// un afiliado a la busqueda).
export function clearAffiliateSession() {
    AFFILIATE_KEYS.forEach(key => sessionStorage.removeItem(key))
}

// Borra SOLO la sesion del operador (contexto de gestion). Se usa al salir
// deliberadamente de gestion ("salir de gestion").
export function clearOperatorSession() {
    OPERATOR_KEYS.forEach(key => sessionStorage.removeItem(key))
}

// Blanket clear: borra TODO sessionStorage. UNICO lugar legal del repo donde
// vive `sessionStorage.clear()` desnudo. Solo debe invocarse cuando NO hay
// contexto de operador que proteger (ver resetAuth en store/auth.js).
export function clearAllSession() {
    sessionStorage.clear()
}
